import { getAvailablePurchaseMethods } from "./getAvailablePurchaseMethods";

export const getCheapestOffersPerPurchaseMethod = (offers) => {
  return getAvailablePurchaseMethods(offers).map((method) => {
    const filteredOffers = offers.filter(
      (offer) => offer.purchaseMethod === method
    );
    return filteredOffers.reduce(
      (min, offer) => (offer.price.amount < min.price.amount ? offer : min),
      filteredOffers[0]
    );
  });
};
